/* eslint-disable no-param-reassign */

export const reverseToInitialFilterValue = (arr, reverse) =>
  arr?.map(option => {
    if (reverse && option?.checked) {
      option.checked = false
    }
    return option
  })
